let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8hEP7")).then(() => parcelRequire('8jgcY'));